import { useState, useEffect } from "react"
import { Icon } from "@planningcenter/tapestry-react"
import { colors } from "components/shared/admin_colors"
import PropTypes from "prop-types"

const optionRowStyles = {
  grid: {
    display: "grid",
    gridTemplateColumns: "46px 1fr 46px",
    alignItems: "center",
    border: "1px solid var(--pane--border-color)",
    borderTop: "none",
    backgroundColor: "var(--t-fill-color-neutral-100)",
    "&:hover": {
      backgroundColor: "var(--t-fill-color-neutral-080)"
    }
  },
  label: {
    color: "var(--t-fill-color-neutral-010)",
    fontSize: "14px",
    padding: "1rem",
    lineHeight: "1.75"
  },
  delete: {
    padding: "0 1rem",
    height: "100%",
    color: "var(--t-fill-color-neutral-040)",
    borderLeft: "1px solid var(--pane--border-color)",
    fontSize: "0.875rem;",
    cursor: "pointer"
  }
}

const DropdownOptionRow = ({
  option: optionFromProps,
  isEditing,
  onUpdateChoice,
  onRemoveChoice,
  onClick,
  innerRef,
  draggableProps,
  dragHandleProps,
  rowStyle,
  index
}) => {
  const [option, setOption] = useState(optionFromProps)

  useEffect(() => {
    isEditing && document.getElementById("dropdown_choice_edit_input").focus()
  }, [isEditing])

  useEffect(() => {
    setOption(optionFromProps)
  }, [optionFromProps])

  const handleKeyDown = e => {
    switch (e.code) {
      case "Enter":
        submit()
        break
      case "NumpadEnter":
        submit()
        break
      case "Escape":
        cancel()
        break
    }
  }

  const handleInputBlur = e => {
    e.relatedTarget?.id === "dropdown_choice_update_button" ? submit() : cancel()
  }

  const cancel = () => {
    setOption(optionFromProps)
    onUpdateChoice({ choice: optionFromProps, id: index })
  }

  const submit = () => {
    onUpdateChoice({ choice: option, id: index })
  }

  return (
    <div css={{ ...rowStyle, ...optionRowStyles.grid }} ref={innerRef} {...draggableProps}>
      <div {...dragHandleProps} className="p-2">
        <Icon style={{ color: colors.neutral_040 }} name="general.threeHorizontalBars" />
      </div>
      <div css={optionRowStyles.label}>
        {isEditing ? (
          <div className="input-btn-lockup">
            <input
              type="text"
              id="dropdown_choice_edit_input"
              value={option}
              onChange={e => setOption(e.target.value)}
              onKeyDown={handleKeyDown}
              onBlur={handleInputBlur}
            />
            <button
              tabIndex="0"
              onKeyDown={handleKeyDown}
              id="dropdown_choice_update_button"
              onClick={submit}
              className="btn2 create-btn f-r xs-btn mt-2p"
            >
              Update
            </button>
          </div>
        ) : (
          <div
            tabIndex={0}
            role="button"
            onKeyDown={e => e.code === "Enter" && onClick(e)}
            onClick={onClick}
          >
            {option}
          </div>
        )}
      </div>
      <button css={optionRowStyles.delete} onClick={() => onRemoveChoice(index)}>
        <Icon name="general.trash" />
      </button>
    </div>
  )
}

DropdownOptionRow.propTypes = {
  option: PropTypes.string,
  isEditing: PropTypes.bool,
  onUpdateChoice: PropTypes.func,
  onRemoveChoice: PropTypes.func,
  onClick: PropTypes.func,
  innerRef: PropTypes.func,
  draggableProps: PropTypes.object,
  dragHandleProps: PropTypes.object,
  rowStyle: PropTypes.object,
  index: PropTypes.number
}

export default DropdownOptionRow
